import { blobToDataUrl } from './blobToDataUrl';

async function blobToBase64(blob) {
    const dataUrl = await blobToDataUrl(blob);

    return dataUrl.split(',')[1];
}

export { blobToBase64 };
